<template>
  <el-dialog :append-to-body="true" id="agreement-layer" title="正元签电子合同注册须知" :visible.sync="dialogVisible" width="506px" :center="true">
    <div class="agreement-content">
      <p>【审慎阅读】您在申请注册流程中点击同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括但不限于：</p>
      <p>1、与您约定免除或限制责任的条款;</p>
      <p>2、与您约定的个人信息收集和使用的条款</p>
      <p>3、与您约定的数字证书的申请和使用的条款;</p>
      <p>4、其他以粗体标识的重要条款内容。</p>
      <p>如您对协议有任何疑问，可向平台客服咨询。</p>
      <p>特别提示：</p>
      <p>当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</p>
      <p @click="showServicesHandle" class="cursor" >《正元签电子合同服务协议》</p>
      <p @click="showPrivacyHandle" class="cursor">《正元签电子合同用户隐私政策》</p>
      <p @click="showCertificateHandle" class="cursor">《正元签电子合同用户数字证书使用协议》</p>
    </div>
    <services ref="services"></services>
    <privacy ref="privacy"></privacy>
    <certificate ref="certificate"></certificate>
  </el-dialog>
</template>
<script>
import services from './services'
import privacy from './privacy'
import certificate from './certificate'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  components: {
    services,
    privacy,
    certificate
  },
  methods: {
    showServicesHandle() {
      this.dialogVisible = false
      this.$refs.services.dialogVisible = true
    },
    showPrivacyHandle() {
      this.dialogVisible = false
      this.$refs.privacy.dialogVisible = true
    },
    showCertificateHandle() {
      this.dialogVisible = false
      this.$refs.certificate.dialogVisible = true
    }
  },
}
</script>
<style scoped>
  .cursor {
    cursor: pointer;
  }
</style>